import React, { useEffect, useState } from "react";
import Link from "@qlik/qlik/src/components/Link";
import { formatDateText } from "@qlik/qlik/src/lib/util/dates";
import Media from "@qlik/qlik/src/components/Media";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { useI18n } from "@qlik/utils/i18nContext";

const HeroBannerBlog = ({ data }) => {
    const { dateTime, topic, title, subtitle, mainImage, author, readTime } = data?.contentfulBlog ?? {};
    const { firstName, lastName, avatar, slug } = author ?? {};
    const [formattedDate, setFormattedDate] = useState("");
    // Check if media assets exist
    const mediaAssetExist = mainImage?.desktopMedia?.length > 0;
    const heroBannerSectionMinHeight = mediaAssetExist ? "xl:min-h-[447px]" : "";
    const heroBannerImageHeight = mediaAssetExist ? "lg:h-[447px]" : "";

    // Get the i18n information for formatting dates
    const { i18n } = useI18n();

    useEffect(() => {
        if (dateTime) {
            const formatted = formatDateText(dateTime, "MMM DD, YYYY", i18n.curr.langCode);
            setFormattedDate(formatted);
        }
    }, [dateTime]);

    return (
        <section className={`hero-banner-blog overflow-hidden lg:py-10 xl:pb-30 ${heroBannerSectionMinHeight}`}>
            <div className={`container ${heroBannerSectionMinHeight}`}>
                <div className={`row ${heroBannerSectionMinHeight}`}>
                    <div className="col-12 lg:col-6 xl:col-7 relative z-2 py-10 lg:pr-10 xl:pt-[104px] xl:pb-0">
                        {topic?.[0]?.title && (
                            <p className="text-base font-medium tracking-wide5 leading-tight mb-2.5 xl:mb-2 text-ocean uppercase">
                                {topic?.[0]?.title}
                            </p>
                        )}

                        {dateTime && (
                            <p className="min-h-[14px] mb-5 text-gray opacity-50 text-sm not-italic font-medium leading-none tracking-wide4 uppercase">
                                {formattedDate}
                            </p>
                        )}

                        {title && (
                            <h1
                                className="mb-4 lg:mb-7.5 title-2 text-with-color"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                            />
                        )}

                        {subtitle && (
                            <p className="mb-3.5 text-gray text-md md:text-2xl xl:mb-4.75 not-italic font-light leading-relaxed tracking-tight6">
                                {subtitle}
                            </p>
                        )}

                        <div className="flex flex-wrap gap-2.5 items-center">
                            {avatar && firstName && (
                                <Link
                                    to={`/blog/${slug}`}
                                    className="flex flex-wrap gap-2.5 items-center hover:no-underline"
                                >
                                    <Media media={avatar} className="w-10 h-10 rounded-full object-cover" />
                                    <p className="text-gray text-sm leading-tight tracking-normal">{`${firstName} ${lastName}`}</p>
                                </Link>
                            )}

                            <div className="w-1 h-1 rounded-full bg-ocean"> </div>

                            {readTime && (
                                <p className="text-ocean text-sm not-italic font-normal leading-tight tracking-normal">
                                    {readTime}
                                </p>
                            )}
                        </div>
                    </div>

                    {mainImage && (
                        <div className="col-12 lg:col-6 xl:col-5 pb-10 lg:pb-0 lg:flex lg:items-center relative">
                            <div className="rounded overflow-hidden w-full xxl:absolute xxl:w-[635px] xxl:h-full xxl:-left-3.75">
                                <Media
                                    media={mainImage}
                                    videoClassName="object-cover relative w-full h-full"
                                    className={`aspect-ratio-70 object-contain w-full h-full ${heroBannerImageHeight}`}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default HeroBannerBlog;
